import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiAxios } from "../api/mockApi";
import logo from "../../assets/scms-logo.png";
import { saveSession } from "../auth/RequireAuth";

export default function Login(){
  const [id, setId] = useState("admin");
  const [pw, setPw] = useState("admin");
  const [err, setErr] = useState("");
  const nav = useNavigate();

  const onSubmit = (e)=>{
    e.preventDefault();
    const url = "/scms/api/uat/uia/actionSecurityLogin.do";
    const body = JSON.stringify({
            id : id,
            pw : pw,
            userSe : "USR",
        });

    apiAxios(url, body, function(res) {
      if(res.apiRes === "Y") {
        //window.sessionStorage.setItem("userInfo", JSON.stringify(res));
        saveSession("userInfo", res);
        nav("/cms/boards/master", { replace: true });
      } else {
          setErr(res.message);
      }
    });
  };

  return (
    <div className="d-flex align-items-center justify-content-center" style={{minHeight:"100vh"}}>
      <div className="card shadow-sm" style={{width:"500px"}}>
        <div className="card-body">
          <div className="mb-3 text-center d-flex align-items-center justify-content-center">
            <div className="fw-bold">
              <img className="brand-logo" src={logo} alt="SCMS" />
            </div>
            <div className="text-muted">관리자 로그인</div>
          </div>
          {err && <div className="alert alert-danger py-2">{err}</div>}
          <form className="input-rounded" onSubmit={onSubmit}>
            <div className="mb-3">
              <label className="form-label">아이디</label>
              <input className="form-control" value={id} onChange={e=>setId(e.target.value)} placeholder="admin@example.com"/>
            </div>
            <div className="mb-3">
              <label className="form-label">비밀번호</label>
              <input type="password" className="form-control" value={pw} onChange={e=>setPw(e.target.value)} placeholder="••••••"/>
            </div>
            <button className="btn btn-primary w-100 btn-rounded">로그인</button>
          </form>
        </div>
      </div>
    </div>
  );
}
